import type { IBasicVideo, IClip, IEvent, IPlaylist } from "@/types";
import { SOURCE_TYPE, VIDEO_TYPE } from "@/constants";

export const isEvent = (vid?: IPlaylist | IEvent | IBasicVideo | null): vid is IEvent => vid?.type === VIDEO_TYPE.EVENT;
export const isPlaylist = (vid?: IPlaylist | IEvent | IBasicVideo | null): vid is IPlaylist => vid?.source_type === SOURCE_TYPE.PLAYLIST;
export const isClip = (vid?: IPlaylist | IEvent | IBasicVideo | null): vid is IClip => vid?.type === VIDEO_TYPE.CLIP;
export const isHighlight = (vid?: IPlaylist | IEvent | IBasicVideo | null): vid is IClip =>
  vid?.type === VIDEO_TYPE.ATHLETE_HIGHLIGHT || vid?.type === VIDEO_TYPE.GAME_HIGHLIGHT || vid?.type === "autohighlight";
